import { render } from "./HrPsbRequests.vue?vue&type=template&id=3a1cd449&scoped=true"
import script from "./HrPsbRequests.vue?vue&type=script&lang=js"
export * from "./HrPsbRequests.vue?vue&type=script&lang=js"

import "./HrPsbRequests.vue?vue&type=style&index=0&id=3a1cd449&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1cd449"]])

export default __exports__